/**
 * Option values for the school outreach forms.
 * Keep the `value`s in sync with functions/src/outreach.ts — the server
 * rejects anything not listed there.
 */

export interface Option {
  value: string;
  label: string;
  hint?: string;
}

export const SPECIALTIES: Option[] = [
  { value: 'nail_technology', label: 'Nail technology' },
  { value: 'hair_cosmetology', label: 'Hairstyling / cosmetology' },
  { value: 'barbering', label: 'Barbering' },
  { value: 'esthetics', label: 'Esthetics' },
  { value: 'lashes_brows', label: 'Lashes / brows' },
  { value: 'makeup', label: 'Makeup' },
  { value: 'massage_therapy', label: 'Massage therapy' },
  { value: 'other', label: 'Other' },
];

export const BUSINESS_STAGES: Option[] = [
  { value: 'practicing_on_models', label: 'Still in school, practicing on models' },
  { value: 'preparing_first_clients', label: 'Preparing to take my first paying clients' },
  { value: 'taking_clients', label: 'Already taking some paying clients' },
  { value: 'operating_independently', label: 'Working independently with a regular clientele' },
];

export const GRADUATION_TIMELINES: Option[] = [
  { value: 'within_3_months', label: 'Within 3 months' },
  { value: '3_to_6_months', label: 'In 3–6 months' },
  { value: '6_to_12_months', label: 'In 6–12 months' },
  { value: 'over_12_months', label: 'More than 12 months away' },
  { value: 'graduated', label: 'I’ve already graduated' },
];

export const SCHOOL_ROLES: Option[] = [
  { value: 'owner_director', label: 'Owner / director' },
  { value: 'admissions', label: 'Admissions' },
  { value: 'instructor', label: 'Instructor / educator' },
  { value: 'career_services', label: 'Career services / student success' },
  { value: 'other', label: 'Other' },
];

export const COLLABORATION_OPTIONS: Option[] = [
  { value: 'forward_invitation', label: 'Forward an invitation to students' },
  { value: 'share_qr_code', label: 'Share a QR code or flyer' },
  { value: 'brief_introduction', label: 'A brief introduction to the business side of a beauty career' },
  { value: 'not_sure', label: 'Not sure yet—let’s talk' },
];

export const AUDIENCE_SIZES: Option[] = [
  { value: 'under_25', label: 'Fewer than 25 students' },
  { value: '25_100', label: '25–100 students' },
  { value: '100_250', label: '100–250 students' },
  { value: 'over_250', label: 'More than 250 students' },
  { value: 'not_sure', label: 'Not sure' },
];

export const BETA_CONSENT_LABEL =
  'Help from Sky may contact me by email about the beta program.';
export const INQUIRY_CONSENT_LABEL =
  'Help from Sky may reply to this inquiry by email.';

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
